import styled from 'styled-components';

import { StyledValue } from './Styled';

const FormattedTariffValueContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

const FormattedTariffValues = ({ exportValue, importValue }) => {
  const netValue = exportValue - importValue;
  const absNetValue = Math.abs(netValue);
  const verb = netValue >= 0 ? 'earned' : 'spent';
  const ValueComponent = netValue >= 0 ? StyledValue.Savings : StyledValue.Costs;

  return (
    <FormattedTariffValueContainer>
      <>
        £{exportValue} export earnings - £{importValue} import costs =
      </>

      <ValueComponent className="d-inline-block">
        £{absNetValue}/year {verb}
      </ValueComponent>
    </FormattedTariffValueContainer>
  );
};

export default FormattedTariffValues;
